// Layout.js
import React, { useEffect, useRef, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Outlet, useLocation } from "react-router-dom";
import Home from "./components/HomePage";
import NewChat from "./components/NewChat";
import Docs from "./components/Docs";
import FAQ from "./components/FAQ";
import Sidebar from "./components/common/Sidebar";
import Topnavigation from "./components/common/Topnavigation";
import "./assets/css/style.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { UserProvider } from "./context/UserContext";
import { useUser } from "./context/UserContext";

function Layout() {
  const { user, setUser } = useUser();
  const APP_API_SECRET = process.env.REACT_APP_API_SECRET || "";
  const APP_API_ENCRYPTION = process.env.REACT_APP_API_ENCRYPTION || "";  
  const location = useLocation();
  const hasNavigated = useRef(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(true);
  const [selectedAgent, setSelectedAgent] = useState("Housing");
  const [chatHistory, setChatHistory] = useState([]);
  const [apiHistory, setApiHistory] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [userData, setUserData] = useState(null);
  const sidebarRef = useRef(null);

  const resetChat = () => {
    setChatHistory([]);
    setApiHistory([]);
    setSuggestions([]);
  };

  const toggleSidebar = () => setIsSidebarCollapsed(prev => !prev);

  useEffect(() => {
    if (hasNavigated.current) return;
    hasNavigated.current = true;

    // set CookieUtils mode
    const secret_level = window.CookieUtils.getCookie("secret_level", {
      secret: APP_API_SECRET,
      secret_level: "secure",
    });
    window.CookieUtils.setMode(secret_level || APP_API_ENCRYPTION);

    const storedData = window.CookieUtils.getCookie("app_data", {
      secret_level: "secure",
      secret: APP_API_SECRET,
    });

    if (!storedData) {
      alert("Please login first");
      window.location.href = `${process.env.REACT_APP_PUBLIC_URL}/pages/login.php`;
      return;
    }

    try {
      const parsed = JSON.parse(storedData);
      
      if (!parsed.user_id) {
        alert("Please login first");
        window.location.href = `${process.env.REACT_APP_PUBLIC_URL}/pages/login.php`;
        return;
      }

      const userData = {
        user_id: parsed.user_id,
        threadId: 0,
        userName:
          parsed.user_name ||
          (parsed.first_name
            ? `${parsed.first_name} ${parsed.last_name || ""}`.trim()
            : ""),
        firstName:
          parsed.first_name ||
          (parsed.user_details && parsed.user_details.first_name) ||
          "",
        lastName:
          parsed.last_name ||
          (parsed.user_details && parsed.user_details.last_name) ||
          "",
        email:
          parsed.email || (parsed.user_details && parsed.user_details.email) || "",
        mobile:
          parsed.mobile || (parsed.user_details && parsed.user_details.mobile) || "",
      };

      setUser(userData);
      setUserData(userData);


    } catch {
      alert("Please login first");
      window.location.href = `${process.env.REACT_APP_PUBLIC_URL}/pages/login.php`;
    }
  }, [APP_API_SECRET, APP_API_ENCRYPTION, setUser]);

  useEffect(() => {
    const isRoot = location.pathname === "/";
    setIsSidebarCollapsed(isRoot);
  }, [location.pathname]);

  return (
    <div className={`chatBoxOuter ${isSidebarCollapsed ? "collapsed" : ""}`}>
      <Sidebar
        ref={sidebarRef}
        isSidebarCollapsed={isSidebarCollapsed}
        chatHistory={chatHistory}
        apiHistory={apiHistory}
        resetChat={resetChat}
        setChatHistory={setChatHistory}
      />

      <div className="chat-box">
        <Topnavigation
          toggleSidebar={toggleSidebar}
          isSidebarCollapsed={isSidebarCollapsed}
          selectedAgent={selectedAgent}
          setSelectedAgent={setSelectedAgent}
        />

        <div id="chatBox">
          <Outlet
            context={{
              selectedAgent,
              chatHistory,
              setChatHistory,
              apiHistory,
              setApiHistory,
              suggestions,
              setSuggestions,
              reloadThreads: () => sidebarRef.current?.reloadHistory(),
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <UserProvider>
      <Router>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/new-chat" element={<NewChat />} />
            <Route path="/docs" element={<Docs />} />
            <Route path="/faq" element={<FAQ />} />
          </Route>
        </Routes>
      </Router>
    </UserProvider>
  );
}